import shopifyEmpireGenericDefaults from '../shopify-empire-generic/config.js';

export default {
  ...shopifyEmpireGenericDefaults,
  includes: ['shopify-empire-generic'],
  product: {
    ...shopifyEmpireGenericDefaults.product,
    priceFormatter: new Intl.NumberFormat('en-AU', { style: 'currency', currency: 'AUD' }),
  },
  Widgets: [
    ...shopifyEmpireGenericDefaults.Widgets.filter(
      (w) => !['Garage', 'SearchHeader', 'CategoryPageCategoriesGrid', 'FitmentTable'].includes(w.name),
    ),
    {
      name: 'Garage',
      location: { selector: '#cm-garage' },
      template: 'fitmentSearch/garage',
    },
    {
      name: 'SearchHeader',
      facetToggleConfig: {
        toggledFacet: { field: 'Universal', term: 'True' },
        fieldsForVisibility: window.Convermax.config?.baseFitmentFields || ['Year', 'Make', 'Model'],
      },
    },
    {
      ...shopifyEmpireGenericDefaults.Widgets.find((w) => w.name === 'CategoryPageCategoriesGrid'),
      useFilterMode: window.Convermax.config?.useTilesFilterMode,
    },
    {
      name: 'FilterSearchBox',
    },
    {
      name: 'VerifyFitment_guide',
      type: 'VerifyFitment',
      location: { insertBefore: '#cm-fitment-table' },
      template: 'fitmentSearch/verifyFitmentGuide',
    },
    {
      ...shopifyEmpireGenericDefaults.Widgets.find((w) => w.name === 'FitmentTable'),
      alwaysShowedCount: 20,
    },
  ],
};
